import { i18n } from '@apps/main/modules/localization/localizationSetup';
import type { TokensForReplacement } from '@apps/main/new-desktop/pages/tripOverview/models';

import { trackErrorAddingBasket } from '@libs/google-analytics-events';

const { t } = i18n.global;

export enum BookingErrorType {
  CommunicationError = 'CommunicationError',
  WrongNumberOfTokens = 'WrongNumberOfTokens',
}
export type TipKey = 'WrongNumberOfTokens' | 'CommunicationError';
export interface BookingError {
  errorType: BookingErrorType;
  header: string;
  descrtiption: string;
}

export function handleBookingError(error: TipKey): BookingError | null {
  trackErrorAddingBasket();
  if (error === BookingErrorType.CommunicationError) {
    return {
      errorType: BookingErrorType.CommunicationError,
      header: t(`tips.CommunicationError.title`),
      descrtiption: t(`tips.CommunicationError.text`),
    };
  }

  if (error === BookingErrorType.WrongNumberOfTokens) {
    return {
      errorType: BookingErrorType.WrongNumberOfTokens,
      header: t(`tips.WrongNumberOfTokens.title`),
      descrtiption: t(`tips.WrongNumberOfTokens.text`),
    };
  }

  return null;
}

export function replaceTokensBeforeGoingToCheckout(
  currentTokens: [string][],
  tokenForReplacements: TokensForReplacement[]
): [string][] {
  return currentTokens.map((token) => {
    const tokenForReplacement = tokenForReplacements.find(
      (tokenForReplacement) => tokenForReplacement.oldToken === token[0]
    );

    if (tokenForReplacement) {
      return [tokenForReplacement.newToken];
    }

    return token;
  });
}
